import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useToastHelpers } from "../Toasts/ToastUtils";

export default function RequireAllowedCourseUser({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { warningToast } = useToastHelpers();

  useEffect(() => {
    if (isAuthenticated) return;

    const from = {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    };

    // Avoid duplicate toasts (including React StrictMode double-invocation in dev)
    // while still showing the message if the user later hits a different protected URL.
    const toastKey = "ca.loginRedirect.toast";
    const toastKeyAt = "ca.loginRedirect.toast.at";
    const fromKey = `${from.pathname}${from.search || ""}${from.hash || ""}`;
    const lastKey = sessionStorage.getItem(toastKey);
    const lastAt = Number(sessionStorage.getItem(toastKeyAt) || 0);
    const isDuplicate = lastKey === fromKey && Date.now() - lastAt < 2000;

    if (!isDuplicate) {
      sessionStorage.setItem(toastKey, fromKey);
      sessionStorage.setItem(toastKeyAt, String(Date.now()));
      warningToast("Login required", "Please log in to access courses.");
    }

    navigate("/login", { replace: true, state: { from } });
  }, [isAuthenticated, location.hash, location.pathname, location.search, navigate, warningToast]);

  if (!isAuthenticated) return null;

  return children;
}
